<template>
	<div>
		<title-header
			class="mb-4"
			:poll-name="poll.name"
			title="CÓDIGO ASIGNADO"
			url-image="/static/img/diagnosis/dashboard.svg"
		>
			<v-layout row wrap justify-end align-center>
				<select-filter
					:items="subsidiaries"
					:selected-value="subsidiarySelected"
					event-name="change-subsidiary"
					@change-subsidiary="changeValue('subsidiary', $event)"
				></select-filter>
				<select-filter
					:items="areas"
					:selected-value="areaSelected"
					event-name="change-area"
					@change-area="changeValue('area', $event)"
				></select-filter>
				<select-filter
					:items="employees"
					:selected-value="employeeSelected"
					item-text="fullName"
					item-value="id"
					event-name="change-employee"
					@change-employee="changeValue('employee', $event)"
				></select-filter>
				<download-btn
					alt="Descargar reporte en PDF"
					:height="27"
					url-image="/static/img/icons/pdf.svg"
					@download-item="downloadReport('pdf')"
				></download-btn>
				<download-btn
					alt="Descargar reporte en Excel"
					:height="23"
					url-image="/static/img/icons/excel.webp"
					@download-item="downloadReport('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')"
				></download-btn>
			</v-layout>
		</title-header>
		<v-layout wrap pb-5 mb-5>
			<v-flex xs10 pr-2>
				<v-layout wrap>
					<v-flex xs12 pr-2>
						<div class="graphic-bar">
							<card-chart
								:labels="labels"
								:percentage="percentage"
								:series-labels="seriesLabel"
								:max="employeeId ? 15 : 100"
							/>
							<div style="padding-right: 45px">
								<card-chart-icons :icons="factorsSelect" />
							</div>
						</div>
					</v-flex>
					<v-flex xs12 pr-2>
						<div class="wrapper-legend-chart flex">
							<row-graphic
								:average="average"
								:border="false"
								legend-border-right
								:legends="legends"
								:row="graphic"
								view-legend
							/>
						</div>
					</v-flex>
					<v-flex xs12 pt-3>
						<v-layout wrap>
							<template v-for="z in 13">
								<v-flex xs2 pr-2 :key="z" v-if="z > 7">
									<card-information class="card-bottom" :data="factors[z]"/>
								</v-flex>
							</template>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs2>
				<v-layout wrap>
					<v-flex xs12 v-for="n in 8" :key="n">
						<card-information class="card-right mgb-5" :data="factors[n-1]"/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="wrapper-close"
			:style="`border-color:${$appColors.gray};background-color:${$appColors.white}`"
		>
			<v-btn
				class="btn-detail btn-action ml-5"
				color="primary"
				@click="goToBack"
			>
				Atrás
			</v-btn>
		</div>
	</div>
</template>

<script>
import selectFilter from '@/components/diagnosis/select-filter';
import cardChart from '@/components/diagnosis/card-chart';
import cardInformation from '@/components/diagnosis/card-information';
import downloadBtn from '@/components/diagnosis/download-btn';
import helper from '@/shared/helper';
import rowGraphic from '@/components/surveys/action-one/row-graphic';
import titleHeader from '@/components/diagnosis/title-header';
import toolsCodes from '@/shared/tools-codes';
import CardChartIcons from '@/components/diagnosis/card-chart-icons';

const { OrgaDiagnosis } = toolsCodes;
const { generateBlob, showDownloadDialog } = helper;

async function created() {
	({ data: this.subsidiaries } = await this.$httpPraktiko.get('subsidiaries'));
	const newSubsidiary = { code: 'SUB0', id: null, name: 'Todas las Sucursales' };
	this.subsidiaries.unshift(newSubsidiary);
	this.loadData();
}

async function downloadReport(type, contentType) {
	const body = {
		id: this.detailId,
	};
	if (this.areaId) {
		body.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		body.subsidiaryId = this.subsidiaryId;
	}
	if (this.employeeId) {
		body.employeeId = this.employeeId;
	}
	const myGraphs = document.getElementById('bar-chart').toDataURL();
	const graphs = [myGraphs];
	if (type !== 'xlsx') {
		body.base64 = graphs;
	}
	if (type === 'xlsx') {
		body.excel = true;
	}
	try {
		const { data: pdfData } = await this.$httpPraktiko.post(
			`reports/organizational-diagnosis/${type}`, body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'reporte_diagnostico_organizacional', type);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function goToBack() {
	const { toolId } = this.$route.params;
	this.goTo('detail-diagnoses', { params: { toolId, id: this.id } });
}

function changeValue(selection, value) {
	if (selection === 'area') {
		this.areaId = value;
	}
	if (selection === 'subsidiary') {
		this.subsidiaryId = value;
	}
	if (selection === 'employee') {
		this.employeeId = value;
	}
	this.loadData();
}

async function loadData() {
	const params = {};
	if (this.areaId) {
		params.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		params.subsidiaryId = this.subsidiaryId;
	}
	if (this.employeeId) {
		params.employeeId = this.employeeId;
	}
	const request = [
		this.$http.get(`hierarchies/${OrgaDiagnosis}`),
		this.$httpPraktiko.get(
			`diagnostic-detail/${this.detailId}/item`, { params }),
	];
	try {
		[{ data: this.factors }, { data: this.model }] = await Promise.all(request);
		this.graphic = [
			{
				image: '/static/img/diagnosis/app.svg',
				number: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numApplicants : this.model.totalResolved,
				numberTotal: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numApplicants : this.model.numApplicants,
				description: 'Aplicantes',
			},
			{
				image: '/static/img/diagnosis/male.svg',
				number: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numMale : this.model.numMale,
				numberTotal: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numMale : this.model.numTotalMale,
				description: 'Masculino',
			},
			{
				image: '/static/img/diagnosis/female.svg',
				number: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numFemale : this.model.numFemale,
				numberTotal: this.areaId || this.subsidiaryId ?
					this.model.reportData[0].numFemale : this.model.numTotalFemale,
				description: 'Femenino',
			},
			{
				textBlue: 'PROMEDIO DE EDADES',
				number: this.model.averageAge,
				description: 'años',
				code: 'age',
			},
			{
				textBlue: 'AÑOS DE SERVICIO',
				number: 10,
				description: 'años',
				code: 'year',
			},
		];
		this.factorsSelect = this.model.reportData.map((r) => {
			const newR = {
				id: r.hierarchyId,
				image: r.urlImage,
				percentage: r.percentage,
				percentageAverage: r.percentageAverage,
			};
			return newR;
		});
		this.factors = this.factors.map((f) => {
			const factorSelected = this.factorsSelect.find(fs => fs.id === f.id);
			const entitySelected = this.model.reportData.find(rd => rd.hierarchyId === f.id);
			const newF = {
				id: f.id,
				active: !!factorSelected,
				description: entitySelected ? entitySelected.description : '',
				visible: true,
				image: f.urlImage,
				name: f.name,
				percentage: (factorSelected || {}).percentage || 0,
				average: (factorSelected || {}).percentageAverage || 0,
				value: f.percentage || 0,
				numApplicants: this.model.numApplicants,
				numMale: this.model.numMale,
				numFemale: this.model.numFemale,
			};
			return newF;
		});
		const activeFactors = this.factors.filter(f => f.active);
		const employeeIds = this.model.employeeDiagnostic.map(emp => emp.employeeId)
			.join(',');
		const param = { employeeIds };
		({ data: this.employees } = await this.$httpPraktiko.get('employee', { params: param }));
		this.employees = this.employees.map((e) => {
			const newE = { ...e };
			newE.fullName = `${e.name} ${e.lastName}`;
			return newE;
		});
		const newEmployee = { code: 'EMP0', id: null, fullName: 'Todos los Empleados' };
		this.employees.unshift(newEmployee);
		const newArea = { code: 'GE01', id: null, name: 'Todas las Áreas' };
		this.model.groups.unshift(newArea);
		this.areas = this.model.groups.map(ac =>
			({ code: ac.code, id: ac.id, name: ac.name }));
		this.average = activeFactors.map(af => af.average);
		if (this.employeeId) {
			this.percentage = this.model.reportData.map(r => r.entities.map(e => e.value));
			this.seriesLabel = this.model.reportData.map(r => r.entities.map(e => e.name));
		} else {
			this.percentage = activeFactors.map(af => af.percentage);
			this.seriesLabel = this.model.reportData[0].entities.map(e => e.name);
		}
		this.labels = activeFactors.map(af => af.name);
		this.poll = this.model.poll;
	} catch (err) {
		if (err.status === 500) {
			// this.showGenericError();
			this.showGenericError('No hay coincidencias entre la agencia y el área seleccionada. Asegúrate de que ambos datos sean correctos.');
		}
	}
}

function data() {
	return {
		areaId: null,
		subsidiaryId: null,
		employeeId: null,
		areas: [],
		areaSelected: null,
		subsidiaries: [],
		subsidiarySelected: null,
		employees: [],
		employeeSelected: null,
		average: [],
		factors: [],
		factorsSelect: [],
		graphic: [],
		labels: [],
		seriesLabel: [],
		legends: [
			{ color: '#5ed52b', name: 'Porcentaje' },
			{ color: '#545a54', name: 'Promedio' },
		],
		model: {},
		percentage: [],
		poll: {},
	};
}

export default {
	name: 'diagnoses-summary',
	components: {
		CardChartIcons,
		// areaFilter,
		// subsidiaryFilter,
		selectFilter,
		downloadBtn,
		cardChart,
		cardInformation,
		rowGraphic,
		titleHeader,
	},
	created,
	data,
	methods: {
		downloadReport,
		goToBack,
		loadData,
		changeValue,
	},
	props: {
		detailId: [Number, String],
		id: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-graphic-bar {
		width: 80%;
	}
	.graphic-bar {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
		margin-bottom: 18px;
		padding: 65px 13% 24px 8%;
		width: 100%;
	}
	.wrapper-legend-chart {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		padding: 16px 1% 16px 6%;
		width: 100%;
	}

	.flex {
		display: flex;
	}

	.justify-between {
		justify-content: space-between;
	}

	.wrapper-column {
		align-items: flex-start;
		flex-direction: column;
	}

	.wrapper-close {
		align-items: center;
		border-top: 1px solid;
		bottom: 0;
		display: flex;
		justify-content: center;
		padding: 16px 0 19px 0;
		position: fixed;
		left: 70px;
		right: 0;
	}

	.m-100 {
		margin-bottom: 110px;
	}

	.mgb-5 {
		margin-bottom: 5px;
	}
</style>





// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnoses-summary.vue